module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Ruman Neupane was born in Bhaktapur, Nepal, a medieval town founded in the 12th century. Currently, he resides in Australia with his wife, Pratiksha, and son, Ryan.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    }
  }, [_vm._v("He is an avid reader and writer who is deeply influenced by Nietzschean philosophy. He is particularly drawn to the pessimistic style of Schopenhauerian writing, which he believes accurately reflects the human condition.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    }
  }, [_vm._v("Ruman has previously published two books, both of which were well received by readers and critics. This book is his third, and he hopes that it will be just as well received as his previous works. In his writing, Ruman combines elements of Hindu and Greek mythology to create a unique and compelling narrative. He is deeply interested in the philosophical dynamics of Hinduism, and this is reflected in his writing. His taste in music is eclectic, but he is a core follower of "), _c('em', [_vm._v("The Doors")]), _vm._v(" and "), _c('em', [_vm._v("Freddie Mercury")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0